import * as React from "react";
import {
    PlasmicProjectpage,
    DefaultProjectpageProps
} from "./plasmic/main/PlasmicProjectpage";
import {useParams} from "react-router-dom";

export interface ProjectpageProps extends DefaultProjectpageProps {
    user?: any
}

export default function Projectpage({user, ...rest}: ProjectpageProps) {
    let params = useParams();
    const projectID = params.projectID;

    return <PlasmicProjectpage
        {...rest}
        canvasView={{
            projectID: projectID,
            user: user
        }}
    />;
}
